import { RiTerminalBoxLine } from '@remixicon/react';

import { DateUtils } from '@spotify/confidence-core-react';
import {
  ExternalUrlArtifactContent,
  ExternalUrlArtifactListItem,
  createArtifactExtension,
  getCodingSessionUrl,
  isCodingSessionArtifact,
} from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';

export const CodingSessionArtifactExtension = projectsPlugin.provide(
  createArtifactExtension({
    id: 'coding-session',
    predicate: isCodingSessionArtifact,
    icon: () => ({
      Icon: RiTerminalBoxLine,
      color: 'var(--bui-fg-primary)',
    }),
    label: 'Coding session',
    category: 'Coding sessions',
    render: artifact => (
      <ExternalUrlArtifactContent
        artifact={artifact}
        href={getCodingSessionUrl(artifact)}
      />
    ),
    renderListItem: (artifact, { onDelete, onRename, icon }) => {
      const href = getCodingSessionUrl(artifact);
      return (
        <ExternalUrlArtifactListItem
          artifact={artifact}
          icon={icon}
          subtitleLabel="Coding session"
          openLabel="Open coding session"
          href={href}
          createTimeFormat={DateUtils.SHORT_MONTH_DAY_TIME_FORMAT}
          onDelete={onDelete}
          onRename={onRename}
        />
      );
    },
  }),
);
